/**
 * Opens a URL in a new window with specified properties.
 * @param url The URL to open.
 * @returns The new window object or null if blocked.
 */
export const openInNewWindow = (url: string) => {
  const result = window.open(url, '_blank');
  result?.focus();
  return result;
};
